import axios from "axios";
import {shieldHeaders} from "../http_common";
let burl = process.env.VUE_APP_API;

export function getIdccFromNAF(naf){
    return axios.get(burl + '/api/idcc/getIdccFromNAF?naf=' + naf,{
        headers : shieldHeaders
    });
}
